import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../connectionString';
import { SurveySaveModel } from '../../modules/survey-via-link/SurveySave.model';

@Injectable()
export class SurveyViaLinkServiceService {

  constructor(private http: HttpClient) {}
  accessSurveyLink(linkCode: string) {
    var Headers = new HttpHeaders({
      'No-Auth': 'True'
    });

    return this.http.get(globalAdd.Paneladdress + 'api/SurveyManagement/accessSurveyLink?linkCode='+ linkCode
  , {
      headers: Headers
    });
  }

  saveSurvey(finalModal:SurveySaveModel) {
    var Headers = new HttpHeaders({
      'No-Auth': 'True'
    });
    return this.http.post(globalAdd.Paneladdress + 'api/SurveyManagement/saveSurvey', finalModal, {
      headers: Headers
    });
  }

  submitSurvey(finalModal:SurveySaveModel) {
    var Headers = new HttpHeaders({
      'No-Auth': 'True'
    });
    return this.http.post(globalAdd.Paneladdress + 'api/SurveyManagement/submitSurvey', finalModal, {
      headers: Headers
    });
  }

}
